import React from 'react';
import { Caption } from 'components/Typography/Typography';
import UnlimitedIcon from '@material-ui/icons/AllInclusive';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/usageStyle';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(styles);

interface IUnlimitedProps {
	subheader: string;
}

const Unlimited = ({ subheader }: IUnlimitedProps) => {
	const classes = useStyles();

	return (
		<div>
			<Caption color="secondary-light">{subheader}</Caption>
			<UnlimitedIcon className={classes.unlimitedIcon} />
		</div>
	);
};

export default Unlimited;
